import React from "react";
import cx from "classnames";

import s from "./MarketFilterCategories.module.scss";
import FilterPill from "./FilterPill";

export default function MarketFilterCategories({
	categories = [],
	className = "",
	toggleCategory = () => {},
}) {
	// ------------------------------------- METHODS -------------------------------------

	return (
		<div className={cx(s.root, className)}>
			{categories.map((cat, index) => (
				<FilterPill
					key={index}
					className={s.pill}
					category={cat}
					isSelected={cat.isSelected}
					onClick={() => toggleCategory(cat)}
				/>
			))}
		</div>
	);
}
